import React            from 'react';
import PropTypes        from 'prop-types';
import { 
    Container,
    Wrapper,
    ContentWrapper,
    Base,
}                       from './components';

class Textfield extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            type         : props.type,
            value        : '',
            isFocused    : false,
        };

        this.base = React.createRef();

        this.onChangeHandler    = this.onChangeHandler.bind(this);
        this.onClickHandler     = this.onClickHandler.bind(this);
        this.onBlurHandler      = this.onBlurHandler.bind(this);
    }

    createComponentClasses() {
        let {
            size,
            full,
            className,
        } = this.props;

        let classNames = [];
        if (size)                                      classNames.push(size)
        if (full)                                      classNames.push('full');
        if (className)                                 Array.prototype.push.apply(classNames, className.split(' '));

        return [...new Set(classNames)].join(' ');
    }

    componentDidMount(){
        let { value } = this.props;
        let defaultValue = value !== undefined
                                ? value
                                : '';
        this.setState({
            value       : defaultValue
        });  
    }

    componentDidUpdate(prevProps, _prevState) {
        let val = this.props.value !== undefined
                    ? this.props.value
                    : ''

        if(prevProps.value !== this.props.value) {
            this.setState({ 
                value       : val
            });
        }
        let types = this.props.type !== undefined
                    ? this.props.type
                    : ''

        if(prevProps.type !== this.props.type) {
            this.setState({ 
                type       : types
            });
        }
    }

    onChangeHandler(e) {
        e.persist();
        let { onChange } = this.props;
        this.setState({
            value       : e.target.value,
        }, () => {
            if(onChange) {
                onChange(e.target.value);
            }
        });
    }

    onClickHandler(e) {
        e.persist()
        this.refs.BASE.refs.INPUT.focus();
        this.setState({ 
            isFocused: true
        });
    }

    onBlurHandler(e) {
        this.setState({ 
            isFocused   : false
        });
    }

    render(){
        const p       = this.props;
        const s       = this.state;
        return(
            <Container className= { this.createComponentClasses() }>
                <Wrapper
                    isFocused           = { s.isFocused }
                >
                    <ContentWrapper>
                        <Base 
                            type            = { s.type }
                            placeholder     = { p.placeholder }
                            attrs           = { p.attrs }
                            value           = { s.value === null ? '' : s.value }
                            ref             = 'BASE'
                            onBlur          = { e => this.onBlurHandler(e) }
                            onChange        = { e => this.onChangeHandler(e) }
                            onFocus         = { e => this.onClickHandler(e) }
                        />
                    </ContentWrapper>
                </Wrapper>
            </Container>
        )
    }
}

Textfield.propTypes = {
    type                : PropTypes.oneOf(['text', 'password','email','phone','number', 'date', 'tel', 'url']),
    placeholder         : PropTypes.string,
    full                : PropTypes.bool,
    className           : PropTypes.string,
    size                : PropTypes.string,
    onChange            : PropTypes.func,
};

Textfield.defaultProps = {
    type                : 'text',
    full                : false,
    placeholder         : '',
    size                : '',
    className           : '',
    onChange            : () => {},
};

export default Textfield;